import React, {useEffect} from 'react';
import '../assets/templates/PrePost.css';
import {getVideoUrl, isEmpty} from "../lib/utils";
import useVideoPlayback from "../hooks/useVideoPlayback";
import { t } from "../lib/i18n";

const PrePost = ({ blockData }) => {

    // const {togglePlay, overridePlayAction, isLessonPlaying, next} = useLessonNavigation();
    const {vimeoBuilder, cleanup} = useVideoPlayback(getVideoUrl(blockData.videoId),  'pre_post')

    const VimeoComponent = vimeoBuilder({ responsive: true});

    useEffect(() => {
        return () => {
            cleanup();
        }
    }, []);

    return (
        <>
            <div className="default-card">
                <div className='prepost-container-video'>
                    {!blockData.loading ? (
                        !isEmpty(blockData.videoId) ? (
                            <div>
                                {VimeoComponent}
                            </div>
                        ) : (
                            <div>{t("No video available")}</div>
                        )
                    ) : (
                        <div>{t("Loading...")}</div>
                    )}
                </div>
            </div>
        </>
    );
}

export default PrePost;
